<div
  class="container-fluid flex-row justify-content-center mb-0 mb-lg-5 mb-xl-2 mt-md-1 mt-xl-0 pt-3 pt-md-0 pt-xl-0 pb-3 pb-lg-5 pb-xl-2 shadow-lg col-12"
>
  <div class="d-flex shadow-lg">
    <div class="container mb-3 mb-lg-5 pb-lg-5 mb-xl-0 pb-xl-0">
      <div class="row my-5 py-0 py-md-5" *ngIf="!company.created">
        <div
          class="col-12 my-5 py-5 d-flex flex-column justify-content-center"
        >
          <h4 class="rub-head4 text-primary text-center font-weight-bold py-1">
            You have no company set up!
          </h4>
          <h4 class="rub-head4 text-primary text-center font-weight-bold py-1">
            Please set up a company to explore more
          </h4>
          <button
            type="button"
            class="btn btn-info mt-4 mt-lg-5 mb-4 align-self-center"
            routerLink="/admin/companysetup"
          >
            Create company
          </button>
        </div>
      </div>
      <div class="row" *ngIf="company.created">
        <div class="col-xs-12 col-lg-4 mt-2 mt-xl-1 mb-2 mb-lg-1">
          <div class="container mt-0 mt-lg-3 mt-xl-2 mx-0 shadow-lg">
            <div class="row">
              <div class="col-12">
                <h3
                  class="rub-head4 text-info text-center font-weight-bold py-1"
                >
                  Company Logo
                </h3>
              </div>
            </div>
          </div>
          <div class="big-card-1 card mt-2 mt-lg-3 mt-xl-2 pt-2 mb-1 shadow-lg">
            <div class="big-card-body-1 card-body">
              <div class="d-flex justify-content-between align-items-center">
                <img
                  class="mb-2 pb-0 mx-4 mx-xl-3"
                  [src]="companyInfo[0].companyLogoUrl"
                />
              </div>
              <button
                type="button"
                class="btn btn-info col-4 mx-4 mx-xl-3 mb-0"
                (click)="enableEdit()"
              >
                Edit
              </button>
            </div>
            <input
              *ngIf="showInput"
              type="file"
              src="image/*"
              class="form-control mt-2 mb-2"
              (change)="onFileSelected($event)"
            />
          </div>
        </div>
        <div class="col-xs-12 col-lg-8 mt-0 mt-lg-2 mt-xl-1 mb-1 mb-lg-1">
          <div class="container mt-0 mt-lg-3 mt-xl-2 mx-0 shadow-lg">
            <div class="row">
              <div class="col-12">
                <h3
                  class="rub-head4 text-info text-center font-weight-bold py-1"
                >
                  Company Details
                </h3>
              </div>
            </div>
          </div>
          <div
            class="big-card-2 card mt-2 mt-lg-3 mt-xl-2 pt-2 pt-lg-4 pt-xl-3 mb-2 pb-1 pb-md-0 pb-lg-4 pb-xl-3 shadow-lg"
          >
            <div
              class="big-card-body-2 card-body mx-auto mx-md-0 mx-xl-auto px-auto px-xl-3 px-md-0 mb-md-0 pb-md-3 pb-lg-2"
            >
              <div
                class="list-card2 card mt-2 mt-lg-1 pt-1 pt-lg-2 pt-xl-1 mb-2 mb-md-0 mb-lg-1 mx-auto mx-md-0 mx-xl-auto px-0 px-xl-2 pb-3 shadow-lg"
              >
                <div
                  class="list-card-body-2 card-body mt-0 pt-1 mb-0 pb-0 mx-auto px-auto px-lg-1 mx-lg-0"
                >
                  <div class="row my-0 py-0 px-xl-0 mx-xl-0">
                    <div
                      class="col-12 col-md-4 mt-0 pt-2 mx-auto px-auto mx-lg-0 px-lg-0"
                    >
                      <!--add data from the database next to the span after &nbsp;-->
                      <span class="itemCreated-1">Name: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyName
                      }}</span
                      ><br />
                      <span class="itemCreated-1"
                        >Office floor: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyOfficeFloor
                      }}</span
                      ><br />
                      <span class="itemCreated-1"
                        >Building: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyStreetBuilding
                      }}</span
                      ><br />
                      <span class="itemCreated-1"
                        >Plot No.: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyPlotNumber
                      }}</span
                      ><br />
                      <span class="itemCreated-1"
                        >Street name: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyStreetBuilding
                      }}</span>
                    </div>
                    <div
                      class="col-12 col-md-4 mt-0 pt-2 mx-auto px-auto mx-lg-0 px-lg-0"
                    >
                      <span class="itemCreated-1">City: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyCityLocation
                      }}</span
                      ><br />
                      <span class="itemCreated-1">Region: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyRegionLocation
                      }}</span
                      ><br />
                      <span class="itemCreated-1">Country: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyCountryLocation
                      }}</span
                      ><br />
                      <span class="itemCreated-1">Box No.: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyBoxNumber
                      }}</span>
                    </div>
                    <div
                      class="col-12 col-md-4 mt-0 pt-2 mx-auto px-auto mx-lg-0 px-lg-0"
                    >
                      <span class="itemCreated-1">Email 1: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyEmail1
                      }}</span
                      ><br />
                      <!--display second email only if given-->
                      <span class="itemCreated-1">Email 2: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyEmail2
                      }}</span
                      ><br />
                      <span class="itemCreated-1"
                        >Phone contact 1: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyPhoneContact1
                      }}</span
                      ><br />
                      <!--display second email only if given-->
                      <span class="itemCreated-1"
                        >Phone contact 2: &nbsp;&nbsp;</span
                      ><span class="itemCreated-2 text-info">{{
                        companyInfo[0].companyPhoneContact2
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="company.created">
        <div class="col-xs-12 col-lg-8 mt-lg-2 mt-xl-0 mb-2 mb-xl-0">
          <div class="container mt-0 mx-0 shadow-lg">
            <div class="row">
              <div class="col-12">
                <h3
                  class="rub-head4 text-info text-center font-weight-bold py-1"
                >
                  Approvals
                </h3>
              </div>
            </div>
          </div>
          <div class="big-card-4 card mt-2 mt-lg-3 mt-xl-2 pt-2 mb-0 pb-1 pb-xl-2 shadow-lg">
            <div class="big-card-body-4 card-body mx-auto px-auto">
              <div class="row" *ngIf="!company.created">
                <div
                  class="col-12 my-3 d-flex flex-column justify-content-center"
                >
                  <!-- <div class="col-12"> -->
                  <h4
                    class="rub-head4 text-primary text-center font-weight-bold py-1"
                  >
                    Your have no approval levels set!<br />
                  </h4>
                  <button
                    type="button"
                    class="btn btn-info my-2 align-self-center"
                    routerLink="/admin/approvalsetup"
                  >
                    Set Approval Level
                  </button>
                </div>
              </div>
              <div class="row" *ngIf="company.created">
                <div class="col-12">
                  <div class="row">
                    <div class="col-7 col-md-8">
                      <h4 class="list-head-1 text-center text-info">Item</h4>
                    </div>
                    <div class="col-5 col-md-4 ml-0">
                      <h4 class="list-head-2 text-center text-info">Levels</h4>
                    </div>
                  </div>
                  <div class="iteration mt-1 mb-1 py-1">
                    <div class="item-container my-0 py-0" *ngFor="let item of approvals">
                      <div
                        class="list-card-4 card mt-0 mb-1 py-2 mx-0 px-0 shadow-lg"
                      >
                      <div class="list-card-body-4 card-body my-0 py-0 mx-0">
                          <div
                            class="row my-0 py-0"
                            routerLink="/admin/approvalsetup"
                          >
                            <div class="col-7 col-md-8 my-0 py-0 mx-0 px-0">
                              <span class="itemCreated-3">{{
                                item.itemName
                              }}</span>
                            </div>
                            <div class="col-5 col-md-4 mt-0 pt-0 mx-0 px-0">
                              <span class="levelSet">{{
                                item.approvalLevel
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-xs-12 col-lg-4 mt-1 mt-lg-2 mt-xl-0 mb-0">
            <div class="container mt-0 mx-0 shadow-lg">
              <div class="row">
                <div class="col-12">
                  <h3
                    class="rub-head4 text-info text-center font-weight-bold py-1"
                  >
                    Business Units
                  </h3>
                </div>
              </div>
            </div>
          <div class="big-card-3 card mt-2 mt-lg-3 mt-xl-2 pt-2 mb-0 pb-1 pb-xl-2 shadow-lg">
              <div class="row" *ngIf="!company.created">
                <div
                  class="col-12 mt-3 mb-0 d-flex flex-column justify-content-center"
                >
                  <!-- <div class="col-12"> -->
                  <h4
                    class="rub-head4 text-primary text-center font-weight-bold py-0"
                  >
                    Your have no business units created yet! <br />
                  </h4>
                  <button
                    type="button"
                    class="btn btn-info my-1 align-self-center"
                    routerLink="/admin/businessunits"
                  >
                    Create business unit
                  </button>
                </div>
              </div>
              <div class="row" *ngIf="company.created">
                <div class="col-12">
                  <h4 class="list-head-3 text-info text-center">Unit</h4>
                </div>
              </div>
            <div class="big-card-body-3 card-body mx-auto px-auto pb-xl-3"
                *ngIf="company.created"
              >
                <div class="row">
                  <div class="col-12">
                  <div class="iteration mt-1 mb-2 py-1">
                    <div
                      class="item-container my-0 py-0"
                      *ngFor="let Units of bussinessUnits"
                    >
                      <div
                        class="list-card-3 card mt-0 mb-1 py-2 mx-0 px-0 shadow-lg"
                      >
                        <div
                          class="list-card-body-3 card-body my-0 py-0 mx-0"
                        >
                          <div
                            class="row my-0 py-0"
                            routerLink="/admin/businessunits"
                          >
                            <div class="col-12 mt-0 pt-0 mx-0">
                              <span class="itemCreated text-center">{{
                                Units.bussinessUnitName
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
